<template>
  <div class="dashboard-main-content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <div class="form-box">
            <div class="form-title-wrap">
              <div class="d-flex align-items-center justify-content-end">
                <a href="javascript:void(0)" @click="show" :href="basePath+'/pricings/new'" class="theme-btn theme-btn-small">
                  <i class="la la-plus mr-1"></i>
                  Yeni Fiyatlandırma Yarat
                </a>
              </div>
            </div>
            <div class="form-content pb-2" v-if="priceList != null">

              <h3 class="title">Fiyatlandırma Şablon Listesi</h3>
              <p class="font-size-14">{{ priceList.length }} listeleniyor</p>

              <div class="table-form table-responsive">
                <table class="table">
                  <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th>Adı</th>
                    <th></th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="price in priceList">
                    <th scope="row"><a :href="basePath+'/additional-service/pricings/'+price.id">#{{ price.id }}</a></th>
                    <th>{{ price.name }}</th>
                    <td>
                      <div class="row">
                        <div class="table-content mr-2" v-on:click="deletePrice(price)">
                          <a href="javascript:void(0)" class="theme-btn theme-btn-small" data-toggle="tooltip" data-placement="top" title="" data-original-title="Edit">
                            <i class="la la-trash"></i>
                          </a>
                        </div>
                        <div class="table-content">
                          <a :href="basePath+'/additional-service/pricings/'+price.id" class="theme-btn theme-btn-small" data-toggle="tooltip" data-placement="top" title="" data-original-title="Edit">
                            <i class="la la-edit"></i>
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import messagePopupManager from "../../util/messagePopupManager";
import helper from "../../store/helper/cruiseStoreHelper";

export default {
  name: "AdditionalServicePriceList",
  computed:{
    priceList:{
      get(){
        return this.$store.getters.getAdditionalServicePricingTemplateList;
      }
    },
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    }
  },
  methods:{
    show(){
      this.$store.commit("setPrice",{id:null,image:{}});
    },
    deletePrice(price){
      // messagePopupManager.showDeleteQuestion(() => {
      //   this.$store.dispatch("deletePrice",price).then(response => {
      //     messagePopupManager.showSuccess();
      //   }).catch(error => {
      //     helper.checkDeleteResponseCodeAndShowPopup(error.code);
      //   })
      // })
    }
  },
}
</script>

<style scoped>

</style>